import { getWorkspaceIdFromCurrentUrl } from '@/context/current-workspace';
import { servicesQuery } from '@/services/api';
import { useActiveHealthTab } from '../hooks';
import { TotalsPanel } from './totals-panel';
import { WORKSPACE_HEALTH_REFETCH_INTERVAL } from '@/features/workspace-health';

export function EventsPanel() {
  const workspaceId = getWorkspaceIdFromCurrentUrl() ?? 0;
  const { activeTab } = useActiveHealthTab();

  const totalsQuery = servicesQuery.getEventNamesTotals.useQuery({
    queryKey: ['event-names-totals', workspaceId],
    queryData: { params: { environment_id: workspaceId } },
    refetchInterval: WORKSPACE_HEALTH_REFETCH_INTERVAL,
    enabled: workspaceId > 0 && activeTab === 'data',
  });

  return (
    <TotalsPanel
      title="Events"
      isLoading={totalsQuery.isLoading}
      totals={totalsQuery.data?.body?.totals}
      viewAllHref={`/workspaces/${workspaceId}/journeys/data-index/events`}
      viewAllDestination="events"
    />
  );
}
